import { Box, Button, Modal, TextField, useMediaQuery } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Header from "../../components/Header";
import ModuleCategoryApi from "../../services/api/moduleCategories";

function ModuleCategoryForm({ formData, open, handleClose }) {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isEdit, setIsEdit] = useState(false);

  const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const preventCloseBackdrop = (props) => (
    <div {...props} style={{ pointerEvents: "none" }} />
  );

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: checkoutSchema,

    onSubmit: async (values, { resetForm }) => {
      if (isEdit) {
        editEntity(values);
      } else {
        createEntity(values);
      }

      resetForm();
    },
  });

  useEffect(() => {
    if (formData) {
      formik.setValues({
        ...formData,
      });

      setIsEdit(true);
    } else {
      formik.setValues({
        ...initialValues,
      });
      setIsEdit(false);
    }
  }, [formData]);

  const createEntity = async (values) => {
    const response = await ModuleCategoryApi().create(values);

    console.log(createdSuccessMsg, response);
    handleClose();
  };

  const editEntity = async (values) => {
    const response = await ModuleCategoryApi().edit(formData.id, values);

    console.log(updatedSuccessMsg, response);
    handleClose();
  };

  const modalBody = (
    <Box
      sx={{
        width: "30%",
        bgcolor: "background.paper",
        padding: "15px",
        borderRadius: "8px",
      }}
    >
      <Header title="Module Category Detail" />

      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            marginTop: "15px",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Name"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="name"
            value={formik.values.name}
            inputProps={{ maxLength: 50 }}
            error={!!formik.touched.name && !!formik.errors.name}
            helperText={formik.touched.name && formik.errors.name}
            sx={{ gridColumn: "span 4" }}
          />

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Order No"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="order_no"
            value={formik.values.order_no}
            inputProps={{ maxLength: 10 }}
            error={!!formik.touched.order_no && !!formik.errors.order_no}
            helperText={formik.touched.order_no && formik.errors.order_no}
            sx={{ gridColumn: "span 1" }}
          />

          <Box display="flex" alignItems="center" justifyContent="end" gap={2}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{
                border: "1px solid var(--color-secondary-200)",

                "&:hover": {
                  backgroundColor: "var(--color-secondary-100)",
                  border: "1px solid var(--color-secondary-100)",
                  color: "var(--color-secondary-400)",
                },
              }}
            >
              Close
            </Button>
            <Button type="submit" variant="contained">
              {isEdit ? "Update Module Category" : "Create New Module Category"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      style={modalStyle}
      //   BackdropComponent={preventCloseBackdrop}
    >
      {modalBody}
    </Modal>
  );
}

const checkoutSchema = yup.object().shape({
  name: yup
    .string()
    .required("required")
    .max(50, "Maximum characters limit exceeds"),
  order_no: yup.number().required("required"),
});

const initialValues = {
  name: "",
  order_no: "",
};

const createdSuccessMsg = "Module Category created: ";
const updatedSuccessMsg = "Module Category updated: ";

export default ModuleCategoryForm;
